import { useEffect } from 'react';
import resolutionsStore from './stores/resolution-list-store';
import TranslationScope from '../../translation/translation-scope';
import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import { Outlet } from 'react-router-dom';
import useExpandCollapse from '../../hooks/expand-collapse-hook';


const ResolutionsPage: React.FC = () => {
    const expandCollapseStore = useExpandCollapse();
    
    useEffect(() => {
        resolutionsStore.load();
    }, []);

    return (
        <TranslationScope scope="resolutions">
        <BasePageLayout title="Settings" subTitles={['Resolutions']}>

        <Outlet context={expandCollapseStore} />

        </BasePageLayout>
        </TranslationScope>
    );
}

export default ResolutionsPage;